import { render, staticRenderFns } from "./CompProfileEditDependents.vue?vue&type=template&id=2605c444&scoped=true"
import script from "./CompProfileEditDependents.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditDependents.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605c444",
  null
  
)

export default component.exports